import { Card, Grid } from '@material-ui/core';
import { Text, Paper } from 'library';
import React from 'react';
import { useMediaQuery } from '@mui/material';
import theme from 'theme';

export default function GroupAbout({ about }: { about: JSX.Element }) {
    const mdDown = useMediaQuery(theme.breakpoints.down('md'));
    return mdDown ? null : (
        <Grid style={{ marginBottom: 25 }}>
            <Paper>
                <Grid container item direction="column">
                    <Text bold variant="h2" textStyle={{ paddingBottom: 25 }}>
                        About
                    </Text>
                    <Text variant="body1">{about}</Text>
                </Grid>
            </Paper>
        </Grid>
    );
}
